import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '../Avatar/Avatar';
import { Stack } from '../server/layout/Stack/index';
import { Row } from '../server/layout/Row/index';
const TONE_STYLE = {
    neutral: {
        bg: 'var(--accent)',
        rule: 'var(--primary)',
        ink: 'var(--foreground)',
        attribution: 'var(--muted-foreground)',
    },
    poppy: {
        bg: 'var(--light-poppy)',
        rule: 'var(--primary)',
        ink: 'var(--foreground)',
        attribution: 'var(--muted-foreground)',
    },
    yellow: {
        bg: 'var(--light-yellow)',
        rule: '#6b4f00',
        ink: 'var(--foreground)',
        attribution: 'var(--muted-foreground)',
    },
    brand: {
        bg: 'var(--primary)',
        rule: 'var(--light-poppy)',
        ink: 'var(--background)',
        attribution: 'rgba(255,255,255,0.78)',
    },
};
export function Pullquote({ children, author, attribution, tone = 'neutral', style, }) {
    const t = TONE_STYLE[tone];
    return (_jsx("div", { style: {
            background: t.bg,
            color: t.ink,
            padding: 'var(--space-lg)',
            borderRadius: 'var(--radius-md)',
            borderLeft: `3px solid ${t.rule}`,
            ...style,
        }, children: _jsxs(Stack, { gap: "sm", children: [author && (_jsxs(Row, { gap: "sm", align: "center", children: [author.avatar && _jsx(Avatar, { src: author.avatar, name: author.name, size: 28 }), _jsxs(Stack, { gap: "none", children: [_jsx("span", { style: { font: 'var(--type-body)', fontWeight: 600, color: t.ink }, children: author.name }), author.meta && (_jsx("span", { style: { font: 'var(--type-caption)', color: t.attribution }, children: author.meta }))] })] })), _jsx("span", { style: { font: 'var(--type-body)', lineHeight: 1.6, color: t.ink }, children: children }), !author && attribution !== undefined ? (_jsxs("span", { style: {
                        display: 'block',
                        marginTop: 'var(--space-xs)',
                        font: 'var(--type-overline)',
                        letterSpacing: '0.04em',
                        color: t.attribution,
                    }, children: ["\u2014 ", attribution] })) : null] }) }));
}
//# sourceMappingURL=Pullquote.js.map